import React from "react";
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const MultilineFormInput = ({
  inputLabel,
  placeholder,
  type,
  icon,
  onChange,
  name,
  value,
  error,
  classes,
  isRequired,
  style,
  isdisabled
}) => {
  return (
    <FormControl variant="standard" style={style}  disabled={isdisabled} sx={{ margin: "0px 5px" }}>
      {inputLabel && (
        <>
          <Typography className="field-label">
            {inputLabel}
            {isRequired && <span className="helper-text"> *</span>}
          </Typography>
        </>
      )}
      <OutlinedInput
        placeholder={placeholder}
        className={`${classes}`}
        type={type}
        name={name}
        value={value}
        multiline
        minRows={3}
        onChange={onChange}
        error={error ? true : false}
        sx={{
          margin: "0px",
          fontSize: "14px !important",
          fontFamily: "Poppins !important",
        }}
        startAdornment={
          <>
            {icon && (
              <InputAdornment
                position="start"
                sx={{
                  padding: "0px 0px !important",
                }}
              >
                {icon ? icon : ""}
              </InputAdornment>
            )}
          </>
        }
      />
      <FormHelperText error className={`helper-text`}>
        {error}
      </FormHelperText>
    </FormControl>
  );
};

MultilineFormInput.prototype = {
  inputLabel: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.any,
  icon: PropTypes.object,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  helperText: PropTypes.any,
  error: PropTypes.any,
  classes: PropTypes.any,
  isRequired: PropTypes.bool,
  style: PropTypes.any,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
};
export default MultilineFormInput;
